import { searchEntities } from 'src/store/selectors/search';

// export const selectAssets = state => searchEntities(state, 'assets', ['roomType','customLabel', 'serialNumber', 'item.name', 'item.model', 'item.makeName']);
export const selectAssets = (state) =>
  searchEntities(state, 'assets', ['name', 'customLabel']);